import { createMachine } from 'xstate';
import { Events, UndoCancelationContext } from './types';

const initialContext = {
  error: null,
} as UndoCancelationContext;

export const undoCancelation = createMachine<UndoCancelationContext, Events>({
  id: 'undoCancelation',
  predictableActionArguments: true,
  initial: 'idle',
  context: initialContext,
  states: {
    idle: {
      on: {
        UNDO_CANCELATION: {
          target: 'undoCancelation',
        },
      },
    },
    undoCancelation: {
      invoke: {
        src: 'undoCancelation',
        onDone: {
          target: 'success',
          actions: 'updateSubscription',
        },
        onError: {
          target: 'error',
          actions: 'setError',
        },
      },
    },
    success: {
      type: 'final',
    },
    error: {
      type: 'final',
    },
  },
});
